import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const CarCareTipsCTA = () => {
  return (
    <section
      id="car-care-tips"
      className="bg-black text-white py-16 sm:py-20 border-t border-yellow-500/20"
      data-testid="car-care-tips-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 text-xs uppercase tracking-widest font-semibold mb-5">
          <BookOpen className="w-3.5 h-3.5" />
          Vargas Car Care Blog
        </span>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">
          Car Care Tips &{' '}
          <span className="text-red-500">Roadside Advice</span>
        </h2>

        <p className="mt-5 text-base sm:text-lg text-gray-300 max-w-2xl mx-auto">
          Read helpful tips about oil changes, tires, brakes, batteries, and
          roadside emergencies in Jacksonville.
        </p>

        <div className="mt-8">
          <Link to="/blog">
            <Button
              className="bg-red-600 hover:bg-red-700 text-white px-7 py-6 text-base font-semibold shadow-lg shadow-red-600/30"
              data-testid="visit-blog-btn"
            >
              Visit Our Blog
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CarCareTipsCTA;
